import React from "react";

interface FormHeadingProps {
  title: string;
}

const FormHeading = ({ title = "" }: FormHeadingProps) => {
  return (
    <>
      <h4 className="text-center fw-bold text-decoration-underlin mb-5">
        {title}
      </h4>
    </>
  );
};

export default FormHeading;
